import { render, staticRenderFns } from "./x-circle.vue?vue&type=template&id=018c5fac&"
import script from "./x-circle.vue?vue&type=script&lang=js&"
export * from "./x-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('018c5fac')) {
      api.createRecord('018c5fac', component.options)
    } else {
      api.reload('018c5fac', component.options)
    }
    module.hot.accept("./x-circle.vue?vue&type=template&id=018c5fac&", function () {
      api.rerender('018c5fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/x-circle.vue"
export default component.exports